import type RegisterErrorEnum from "@/src/infrastructure/enums/register-error-enum";

export function getRegisterErrorMessage(
  type: RegisterErrorEnum,
  councilName: string
): string | undefined {
  const messageMap: Record<RegisterErrorEnum, string> = {
    NO_DEVICE_FOUND_WITH_EMAIL: `Currently no device has been assigned to this email address. Please check with the ${councilName}.`,
    USER_ALREADY_EXISTS: "User already exists.",
  };
  return messageMap[type];
}

export default class RegisterError extends Error {
  public readonly type: RegisterErrorEnum;

  constructor(type: RegisterErrorEnum, message?: string) {
    super(message || `Registration error: ${type}`);
    this.name = type.toString();
    Object.setPrototypeOf(this, RegisterError.prototype);
    this.type = type;
  }
}
